export default "__VITE_ASSET__82f49c3f__"